export const translations = {
    filterLabels: {
        // the order is used to sort badges in currentRefinements widget!
        entry_type: 'Inhaltstyp',
        type_institute: 'Kategorie',
        type_beratungsangebote: 'Kategorie',
        type_foerderangebote: 'Kategorie',
        type_medien: 'Kategorie',
        type_plattformen: 'Kategorie',
        type_veranstaltungen: 'Kategorie',
        type_news: 'Kategorie',
        modality: 'Angebotsmodalität',
        audience: 'Zielgruppe',
        topic: 'Thema',
        subject: 'Fach',
    },
    fieldLabels: {
        media_author: 'Autor',
        media_publisher: 'Herausgeber',
        media_publishing_company: 'Verlag',
    },
    menuSelectSeeAllLabel: 'Alle Inhalte anzeigen',
    refinementListShowMoreLabel: '+ Mehr anzeigen',
    refinementListShowLessLabel: '- Weniger anzeigen',
    refinementListCountTitle: 'Ergebnisanzahl für diesen Filter',
    searchBoxPlaceholder: 'Suchbegriff eingeben …',
    searchBoxLabel: 'Volltextsuche',
    searchBoxSubmitAriaLabel: 'Suchen',
    clearRefinementsResetLabel: 'Alle Filter zurücksetzen',
    infiniteHitsShowMoreText: 'Mehr Ergebnisse anzeigen',
    mainCategoryListHeadline: 'Kategorie eingrenzen',
    mainCategoryListResetLabel: 'Inhalts-Filter zurücksetzen',
    stats: {
        noResults: 'Keine passenden Inhalte gefunden',
        countResults: number => `${number} Ergebnisse`,
    },
    noResultsWarning:
        'Für die aktuelle Kombination aus Filtern, Suchbegriff und Standort wurden keine Ergebnisse gefunden.',
};
